import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getCategory = createAsyncThunk("category/getCategory", async (payload) => {
  try {
    const response = await magnifiAPI.getCategory(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const addCategory = createAsyncThunk("category/addCategory", async (payload) => {
  try {
    const response = await magnifiAPI.addCategory(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const modifyCategory = createAsyncThunk("category/modifyCategory", async (payload) => {
  try {
    const response = await magnifiAPI.modifyCategory(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteCategory = createAsyncThunk("category/deleteCategory", async (payload) => {
  try {
    const response = await magnifiAPI.deleteCategory(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const assignCategoryToOrganization = createAsyncThunk(
  "category/assignCategoryToOrganization",
  async (payload) => {
    try {
      const response = await magnifiAPI.assignCategoryToOrganization(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
